import { Alert, Form, Row, message } from 'antd';
import { useWatch } from 'antd/es/form/Form';
import { useForm } from 'antd/lib/form/Form';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormButton } from '../../../components/common/FormItem/FormItems';
import BreadCrumb from '../../../components/common/breadCrumb/BreadCrumb';
import { useGetInvoiceNoQuery } from '../../Invoice(Visa)/Api/Endpoints/invoiceVisaEndpoints';
import InvNonComFlightDetails from '../../Invoice_Non_Comission/components/InvNonComFlightDetails';
import InvNonComFormHeader from '../../Invoice_Non_Comission/components/InvNonComFormHeader';
import InvReIssueTicketInfo from '../Components/InvReIssueTicketInfo';
import NewOrExistingBtn from '../Components/NewOrExistingBtn';
import PostOverviewReIssue from '../Components/PostOverviewReIssue';
import { IReissueFormSubmit } from '../Type/InoviceReissue.interface';
import AirticketPaxPassportDetails from '../../IATA_AIR_TICKET/Components/AirticketPaxPassportDetails';
import { Fixed2 } from '../../../common/utils/common.utils';

type Props = {};

const AddReissueNewClient = ({}: Props) => {
  // @States
  const [invoices, setInvoices] = useState<IReissueFormSubmit[]>([]);
  const [editIndex, setEditIndex] = useState<number | undefined>();
  const [form] = useForm();

  // @GET INVOICE ID
  const { data: invoiceIdData } = useGetInvoiceNoQuery('ARI');
  const invoiceIdServer = invoiceIdData;

  // @SET DEFAULT STATES
  useEffect(() => {
    form.setFieldsValue({
      invoice_sales_date: dayjs(),
      airticket_issue_date: dayjs(),
      dialCode: '+88',
      invoice_no: invoiceIdData?.data,
    });
  }, [invoiceIdServer]);

  // field values
  let penalties = useWatch(['airticket_penalties'], form) || 0;
  let fare_difference = useWatch(['airticket_fare_difference'], form) || 0;
  let client_price = useWatch(['airticket_client_price'], form) || 0;
  let comm_percent =
    useWatch(['airticket_commission_percent'], form) / 100 || 0;
  let purchase_price = useWatch(['airticket_purchase_price'], form) || 0;

  const commissionAmount = Math.round(fare_difference * comm_percent);

  const grossFare = penalties + fare_difference;
  const ait = grossFare * 0.003;
  const actualPrice =
    (grossFare || Number(purchase_price)) - commissionAmount + ait;

  //
  useEffect(() => {
    form.setFieldValue('airticket_commission_percent', 7);
  }, []);

  // set purchase price
  useEffect(() => {
    form.setFieldValue('airticket_purchase_price', grossFare);
    form.setFieldValue('airticket_ait', Math.round(Fixed2(ait)));
  }, [grossFare]);

  //
  useEffect(() => {
    form.setFieldsValue({
      clientPriceSet: client_price,
      purchasePriceSet: actualPrice,
      airticket_profit: Math.round(client_price - actualPrice),
    });
  }, [actualPrice, client_price]);

  // @HANDLE SUBMIT
  const addReissueNewClientHandler = (e: IReissueFormSubmit) => {
    if (!(editIndex || editIndex === 0)) {
      setInvoices((prev) => [...prev, e]);
    } else {
      // @Handle Edit
      setInvoices(
        invoices.map((item, index) => {
          if (index === editIndex) {
            return e;
          }
          return item;
        })
      );
      setEditIndex(undefined);
    }

    // After add notification scroll to top and reset fields
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const oldValues = form.getFieldsValue([
      'invoice_combclient_id',
      'invoice_agent_id',
      'invoice_sales_date',
      'invoice_no',
      'invoice_sales_man_id',
    ]);
    form.resetFields();
    form.setFieldsValue({
      dialCode: '+88',
      invoice_sales_date: dayjs(),
      airticket_issue_date: dayjs(),
      invoice_no: oldValues.invoice_no,
      invoice_agent_id: oldValues.invoice_agent_id,
      invoice_combclient_id: oldValues.invoice_combclient_id,
      invoice_sales_man_id: oldValues.invoice_sales_man_id,
    });
  };

  return (
    <ClientsStyle>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <BreadCrumb arrOfOption={['Air Ticket', 'Re Issue']} />
      </div>

      {/* @NEW CLIENT OR EXISTING CLIENT */}
      <Row justify='center'>
        <NewOrExistingBtn />
      </Row>

      <div className='separator'>
        <div className='left_side'>
          <Form
            form={form}
            labelAlign='left'
            layout='vertical'
            onFinish={addReissueNewClientHandler}
            onFinishFailed={(value) => {
              message.error(
                `Enter all required (${value.errorFields.length}) Fields`
              );
            }}
          >
            {/* INVOICE HEADER */}
            <InvNonComFormHeader form={form} />

            {editIndex || editIndex === 0 ? (
              <>
                <br />
                <Alert
                  message={`Update Active -- ${invoices[editIndex]?.airticket_ticket_no}`}
                />
              </>
            ) : (
              ''
            )}

            {/* TICKET INFORMATION */}
            <InvReIssueTicketInfo
              form={form}
              handleCalculation={() => {}}
              invoices={invoices}
              editIndex={editIndex}
              commissionAmount={commissionAmount}
            />

            {/* PAX DETAILS */}
            <AirticketPaxPassportDetails form={form} formName='pax_passport' />

            {/* FLIGHT DETAILS */}
            <InvNonComFlightDetails form={form} />

            <FormButton
              label={!(editIndex || editIndex === 0) ? 'Add New' : 'Update'}
            />
          </Form>
        </div>

        <div className='right_side'>
          {/* @PREVIEW AND CREATE POST RIGHT SIDE TABLE HERE */}
          <PostOverviewReIssue
            form={form}
            invoices={invoices}
            setEditIndex={setEditIndex}
            setInvoices={setInvoices}
            editIndex={editIndex}
          />
        </div>
      </div>
    </ClientsStyle>
  );
};
export default AddReissueNewClient;
const ClientsStyle = styled.div`
  .separator {
    display: flex;
    gap: 25px;
  }

  .left_side {
    width: 70%;
  }

  .right_side {
    width: 25%;
    position: fixed;
    right: 10px;
  }

  .separator {
    @media only screen and (max-width: 1207px) {
      flex-direction: column !important;
    }
  }
  .left_side {
    @media only screen and (max-width: 1207px) {
      width: 100% !important;
    }
    @media only screen and (min-width: 1208px) {
      width: 67% !important;
    }
    @media only screen and (min-width: 1400px) {
      width: 68% !important;
    }
    @media only screen and (min-width: 1500px) {
      width: 69% !important;
    }
    @media only screen and (min-width: 1600px) {
      width: 70% !important;
    }
  }
  .right_side {
    @media only screen and (max-width: 1207px) {
      width: 100% !important;
      position: static;
    }
    @media only screen and (max-height: 920px) {
      position: sticky;
    }
  }

  .body_left {
    width: 100%;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .body_right {
    width: 100%;
    margin-left: auto;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
  }
  .commonBox {
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      width: 100%;
      margin-bottom: 0.4rem;
    }
  }
  .topLeftButton {
    margin-right: 0.5rem;
    margin-bottom: auto;
  }
`;
